// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --ds-workspace-item-icon-color: var(--ds-color-grey-10);
}

.WorkspaceNavigation-module__Sidebar__As0ha {
    width: var(--ds-70x);
    min-height: 0;
}

.WorkspaceNavigation-module__WorkspaceItem__BwhW_ {
    transition: var(--ds-transition-s);
}

.WorkspaceNavigation-module__WorkspaceItem__BwhW_:hover {
    background-color: var(--ds-interaction-hover);
    cursor: pointer;
}

.WorkspaceNavigation-module__WorkspaceItemLink__Bsb3y {
    flex-grow: 1;
    min-width: 0;
    padding: var(--ds-s);
}

.WorkspaceNavigation-module__WorkspaceItemLink__Bsb3y:focus {
    border-radius: var(--ds-border-radius-sm);
}

.WorkspaceNavigation-module__IconSelected__ePbNl {
    color: var(--ds-workspace-item-icon-color);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Sidebar": `WorkspaceNavigation-module__Sidebar__As0ha`,
	"WorkspaceItem": `WorkspaceNavigation-module__WorkspaceItem__BwhW_`,
	"WorkspaceItemLink": `WorkspaceNavigation-module__WorkspaceItemLink__Bsb3y`,
	"IconSelected": `WorkspaceNavigation-module__IconSelected__ePbNl`
};
export default ___CSS_LOADER_EXPORT___;
